import { createFileRoute } from "@tanstack/react-router";
import { DeskPage } from "../../../components/desk/desk-page";
import { deskSearch } from "../../../lib/desk/search";

/** Medal events the desk settled with no medal — "no medals" decided, or every medal taken away (`GET /medals/no-medals`). */
export const Route = createFileRoute("/_app/award/no-medals")({
	validateSearch: deskSearch,
	component: function NoMedalsDesk() {
		const search = Route.useSearch();
		return <DeskPage list="noMedals" search={search} />;
	},
});
